export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11464.7d9dd70d.jpg";